import { RootState } from "@src/store";

export const isPageStateDismissed = (type: string) => (state: RootState) => {
  return state.experienceBuilder.dismissedPageState[type];
};
